import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit
} from '@angular/core';

import { SiteApiService, SiteService } from '../../core/services/api.service';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html'
})
export class ServicesComponent implements OnInit, AfterViewInit, OnDestroy {

    services: SiteService[] = [];
    loading = false;
    errorMessage = '';

    private observer: IntersectionObserver | null = null;

    constructor(
        private siteApi: SiteApiService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        this.getServices();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initRevealAnimation();
        }, 300);
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    getServices(): void {
        this.loading = true;
        this.errorMessage = '';

        this.siteApi.getServices().subscribe(
            (data: SiteService[]) => {
                this.services = data || [];
                this.loading = false;

                setTimeout(() => {
                    this.initRevealAnimation();
                }, 150);
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Services could not be loaded.';
                this.loading = false;
            }
        );
    }

    private initRevealAnimation(): void {
        const elements = this.elementRef.nativeElement.querySelectorAll('.reveal');

        if (!elements || elements.length === 0) {
            return;
        }

        if (this.observer) {
            this.observer.disconnect();
        }

        this.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const el = entry.target as HTMLElement;
                        el.classList.add('show');
                        this.observer?.unobserve(el);
                    }
                });
            },
            {
                threshold: 0.14
            }
        );

        elements.forEach((el: HTMLElement) => {
            el.classList.remove('show');
            this.observer?.observe(el);
        });
    }
}